import { MCard, MGrid, MSpinner } from "components/Shared";
import { InternetUserListDto } from "interfaces/Mueller.Business.Models";
import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import TextField from "@mui/material/TextField";
import { getUserListWithSearch } from "requests/internetUsers";

interface Props {
  onInternetUserSelected: (user: InternetUserListDto) => any,
}

const InternetUserSearch = (props: Props) => {

  const [searchedInternetUsers, setSearchedInternetUsers] = useState<InternetUserListDto[]>(null);
  const [selectedInternetUser, setSelectedInternetUser] = useState<InternetUserListDto>(null);
  const [searchTerm, setSearchTerm] = useState<string | number>(null);
  const [isSearchingUsers, setIsSearchingUsers] = useState<boolean>(false);

  const mounted = useRef<boolean>(true);

  useEffect(() => {
    return () => { mounted.current = false; };
  }, []);

  const colDefs = [
    { key: "internetuserid", dataSource: "internetUserId", name: "Internet User Id" },
    { key: "username", dataSource: "username", name: "Username" },
    { key: "email", dataSource: "email", name: "Email Address" },
  ];

  const onUserFetchSuccess = (users: InternetUserListDto[]) => {
      let activeUsers = users.filter((u) => u.isDisabled === false);
      setSearchedInternetUsers(activeUsers);
      setIsSearchingUsers(false);
  };

  const onSearch = () => {
    setIsSearchingUsers(true);
    getUserListWithSearch(searchTerm, onUserFetchSuccess, mounted);
  };

  return (<>
    <div className="internet-user-search search-panel">
      {selectedInternetUser ?
        <>
          <MCard
            className="mcard-flat"
            title="Internet User Information"
            fields={[
              { label: "Internet User Id", value: selectedInternetUser.internetUserId },
              { label: "Username", value: selectedInternetUser.username },
              { label: "Email", value: selectedInternetUser.email },
            ]} />
          <div className="search-action-buttons">
            <Button onClick={() => setSelectedInternetUser(null)}>Back</Button>
            <Button onClick={() => props.onInternetUserSelected(selectedInternetUser)}>Select</Button>
          </div>
        </>
        :
        <div className="internetuser-search">
          <div className="search-controls">
            <TextField variant="standard" label="Search Text" onChange={(e) => setSearchTerm(e.target.value)} />
            <Button startIcon={<Icon>search</Icon>} onClick={() => onSearch()} />
          </div>
          {isSearchingUsers ?
            <MSpinner />
            :
            searchedInternetUsers &&
            <MGrid
              columnDefinitions={colDefs}
              data={searchedInternetUsers}
              onRowClick={i => setSelectedInternetUser(searchedInternetUsers[i])}
            />}
        </div>
      }
    </div>

  </>);
};

export default InternetUserSearch;